import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CallEvaluationComponent } from './call-evaluation.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule
  ],
  declarations: [CallEvaluationComponent],
  exports: [CallEvaluationComponent],
  entryComponents: [
    CallEvaluationComponent
  ],
})
export class CallEvaluationModule {}
